import React from 'react'
import { useQueryParam, StringParam } from 'use-query-params'

import { Table } from 'components/Table'
import { filterTriage } from 'pipelines/triage'

import { TriageTableContent } from './TriageTableContent'
import { TriageTableHead } from './TriageTableHead'
import { NoResultSearch } from './NoResultSearch'

export const TriageTable = ({ data }) => {
  const [searchQP] = useQueryParam('search', StringParam)
  const [statusQL] = useQueryParam('status', StringParam)
  const [orderByQP, setOrderByQP] = useQueryParam('orderBy', StringParam)
  const [orientationQP, setOrientationQP] = useQueryParam(
    'orientation',
    StringParam,
  )

  const search = searchQP || ''
  const status = statusQL || ''
  const orderBy = orderByQP || 'folderCompletedAt'
  const orientation = orientationQP || 'desc'

  const lines = filterTriage({
    triage: data,
    search,
    status,
    orderBy,
    orientation,
  })

  const noContent = lines.length < 1

  const toggleOrientation = () =>
    setOrientationQP(orientation === 'desc' ? 'asc' : 'desc')

  const handleOrder = field => {
    if (noContent) return
    setOrderByQP(field)

    if (orderBy === field) {
      toggleOrientation()
    } else {
      setOrientationQP('asc')
    }
  }

  return (
    <>
      <Table css={{ marginTop: '10px' }}>
        <TriageTableHead
          orderBy={orderBy}
          orientation={orientation}
          onOrder={handleOrder}
        />
        <TriageTableContent data={lines} search={search} />
      </Table>
      {noContent && <NoResultSearch />}
    </>
  )
}
